var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map"},[_c('el-amap',{staticStyle:{"height":"314px","width":"686px"},attrs:{"vid":'amapDemo' + _vm.id,"center":_vm.center,"zoom":_vm.zoom,"plugin":_vm.plugin}},[_c('el-amap-marker',{attrs:{"position":_vm.center}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }